import { defineMessages } from 'react-intl';
import type { ConceptStageEnum } from '@foundershub/api-client';

export const conceptStageLabels = defineMessages<ConceptStageEnum>({
  'concept-design': {
    defaultMessage: 'Concept design',
    description: 'project/business stage',
  },
  prototype: {
    defaultMessage: 'Prototype',
    description: 'project/business stage',
  },
  'building-mvp': {
    defaultMessage: 'Building MVP',
    description: 'project/business stage',
  },
  'mvp-in-market': {
    defaultMessage: 'MVP in market',
    description: 'project/business stage',
  },
  'established-market': {
    defaultMessage: 'Established market',
    description: 'project/business stage',
  },
});
